export const Website = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 33 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_2727_27020"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-1"
        y="0"
        width="35"
        height="32"
      >
        <rect x="-0.825012" width="34.7531" height="31.2549" fill="url(#paint0_linear_2727_27020)" />
      </mask>
      <g mask="url(#mask0_2727_27020)">
        <g filter="url(#filter0_i_2727_27020)">
          <rect x="1.95459" y="3.0166" width="29.0908" height="29.1586" rx="1" fill="url(#paint1_linear_2727_27020)" />
          <path
            d="M1.94861 4.00976C1.94861 3.45748 2.39632 3.00977 2.94861 3.00977H30.0762C30.6285 3.00977 31.0762 3.45748 31.0762 4.00977V7.79702H1.94861V4.00976Z"
            fill="#002481"
          />
          <rect x="6.50238" y="21.3682" width="18.829" height="3.66844" rx="0.5" fill="#002481" />
        </g>
      </g>
      <rect x="24.3501" y="4.84082" width="5.36693" height="1.38216" rx="0.5" fill="white" fillOpacity="0.5" />
      <circle cx="4.75092" cy="5.53294" r="1.28684" fill="white" fillOpacity="0.5" />
      <rect x="5.77524" y="10.3281" width="22.068" height="1.97695" rx="0.5" fill="white" fillOpacity="0.5" />
      <rect x="5.77524" y="13.791" width="15.0493" height="1.97695" rx="0.5" fill="white" fillOpacity="0.5" />
      <g filter="url(#filter1_bdd_2727_27020)">
        <path
          d="M17.6596 30.807L13.533 16.5977C13.4276 16.2346 13.7477 15.8904 14.1174 15.9693L28.3545 19.0051C28.7676 19.0932 28.8921 19.6221 28.5617 19.8852L24.654 22.9974C24.4159 23.187 24.401 23.5436 24.6225 23.7523L28.2253 27.1484C28.4233 27.3351 28.4357 27.646 28.253 27.8478L26.0623 30.2685C25.8728 30.4779 25.5476 30.4889 25.3443 30.2927L21.8778 26.947C21.6521 26.7291 21.2837 26.7706 21.1121 27.0333L18.5583 30.941C18.3246 31.2988 17.7788 31.2173 17.6596 30.807Z"
          fill="url(#paint2_linear_2727_27020)"
          shapeRendering="crispEdges"
        />
        <path
          d="M17.8997 30.7372L13.7731 16.528C13.7204 16.3465 13.8804 16.1743 14.0653 16.2138L28.3023 19.2496C28.5089 19.2936 28.5711 19.5581 28.4059 19.6896L24.4982 22.8018C24.1411 23.0862 24.1188 23.6211 24.451 23.9342L28.0538 27.3304C28.1528 27.4237 28.159 27.5791 28.0677 27.68L25.8769 30.1007C25.7822 30.2054 25.6196 30.2109 25.518 30.1129L22.0515 26.7672C21.7128 26.4403 21.1603 26.5025 20.9028 26.8965L18.3491 30.8043C18.2322 30.9831 17.9593 30.9424 17.8997 30.7372Z"
          stroke="#002481"
          strokeOpacity="0.82"
          strokeWidth="0.5"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_2727_27020"
          x="1.94861"
          y="3.00977"
          width="29.1276"
          height="29.165"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.5" dy="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2727_27020" />
        </filter>
        <filter
          id="filter1_bdd_2727_27020"
          x="9.51263"
          y="11.958"
          width="23.2379"
          height="27.21"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2727_27020" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect1_backgroundBlur_2727_27020" result="effect2_dropShadow_2727_27020" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_2727_27020" result="effect3_dropShadow_2727_27020" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_2727_27020" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_2727_27020"
          x1="16.5516"
          y1="24.8583"
          x2="16.5516"
          y2="31.2549"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2727_27020"
          x1="16.5"
          y1="11.929"
          x2="16.5"
          y2="32.1752"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0B4FFF" />
          <stop offset="1" stopColor="#7FE0FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2727_27020"
          x1="16.8175"
          y1="15.7949"
          x2="22.8383"
          y2="28.6743"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.73" />
          <stop offset="1" stopColor="white" stopOpacity="0.86" />
        </linearGradient>
      </defs>
    </svg>
  )
}
